import cx from 'classnames';
import { Icon, InlineEditor, TooltipPortalTrigger } from 'components';
import PropTypes from 'prop-types';
import React from 'react';

function PersonInfoRow({
  label,
  type, // The type of editor to use, for instance 'Input'
  format, // The type of formatting to use for the editor, for instance 'text' or 'phone'
  value,
  onChange,
  placeholder,
  hideAction,
  inputProps,
  showFormatError,
  renderValue: customRenderValue = t => t
}) {
  const Editor = InlineEditor[type];

  if (!Editor && type !== 'Static') {
    console.error(`Editor not found for type - "${type}"`);
    return null;
  }

  const valueCN = cx('info-list__item-value', {
    'info-list__item-value--muted': hideAction,
    'phone-formatted': format === 'phone'
  });

  const renderValue = () => {
    if (type === 'Boolean') return null;

    return value ? (
      <div className={valueCN}>{customRenderValue(value)}</div>
    ) : (
      <div className="info-list__item-value info-list__item-value--empty">{placeholder}</div>
    );
  };

  return (
    <div className="info-list__item person-info-card__row">
      <span>{label}</span>
      {renderValue()}
      <div className="person-info-card__row-content">
        {type !== 'Static' && !hideAction && (
          <Editor type={format || undefined} onChange={onChange} defaultValue={value} {...inputProps} />
        )}
      </div>
      {showFormatError && (
        <div className="alert-right phone-number--invalid">
          <TooltipPortalTrigger tooltip="Please enter a valid phone number" side="center">
            <Icon name="alert" size="18" className="form-input__invalid-icon" />
          </TooltipPortalTrigger>
        </div>
      )}
    </div>
  );
}

PersonInfoRow.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(['Boolean', 'Input', 'Date', 'Static', 'Typeahead', 'Modal']),
  format: PropTypes.oneOf(['text', 'phone']),
  value: PropTypes.any,
  hideAction: PropTypes.bool,
  placeholder: PropTypes.node,
  onChange: PropTypes.func,
  renderValue: PropTypes.func,
  inputProps: PropTypes.object,
  showFormatError: PropTypes.bool
};

PersonInfoRow.defaultProps = {
  type: 'text',
  showFormatError: false
};

export default PersonInfoRow;
